<template>
  <a-dropdown :trigger="['click']" placement="bottomLeft">
    <div :class="$style.dropdown">
      <a-avatar shape="square" size="large" :class="$style.avatar">
        <template #icon>
          <UserOutlined />
        </template>
      </a-avatar>
    </div>
    <template #overlay>
      <a-menu>
        <a-menu-item>
          <a href="javascript: void(0);" @click="handleClickSignOut">
            <i class="fe fe-log-out mr-2" />
            <span class="text-holcim-dark-blue">
              Cerrar Sesión
            </span>
          </a>
        </a-menu-item>
      </a-menu>
    </template>
  </a-dropdown>
</template>

<script>
import { UserOutlined } from '@ant-design/icons-vue'
import { useStore } from 'vuex'
import { computed, inject } from 'vue'

export default {
  components: {
    UserOutlined,
  },
  setup() {
    const store = useStore()
    const user = computed(() => store.getters['user/user'])

    const logout = () => {
      store.dispatch('user/LOGOUT')
    }

    const Vue3GoogleOauth = inject("Vue3GoogleOauth")

    return {
      Vue3GoogleOauth,

      user,
      logout,
    }
  },
  methods: {
    async handleClickSignOut() {
      try {
        // await this.$gAuth.signOut();
        this.$store.dispatch('user/LOGOUT')
      } catch (error) {
        console.error(error);
      }
    },
  },
}
</script>

<style lang="scss" module>
@import './style.module.scss';
</style>
